'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgBus(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M7.828 2h.45l.443.006c2.403.055 4.272.463 4.38 2.345l.005.175v6.316c0 .5-.2.954-.52 1.293l-.112.11v1.123c0 .316-.235.58-.538.625l-.093.007h-.632a.634.634 0 01-.625-.539l-.007-.093v-.631H5.526v.631c0 .316-.234.58-.538.625L4.895 14h-.632a.634.634 0 01-.625-.539l-.006-.093v-1.124a1.893 1.893 0 01-.625-1.237L3 10.842V4.526C3 2.375 5.14 2.018 7.828 2zm4.015 6.315h-7.58v2.527c0 .2.098.345.177.426l.221.206h6.784l.183-.171a.618.618 0 00.207-.366l.008-.095V8.315zm-6 .632a.947.947 0 110 1.895.947.947 0 010-1.895zm4.42 0a.947.947 0 110 1.895.947.947 0 010-1.895zm1.58-3.796h-7.58v1.901h7.58V5.151zM8.316 3.264l-.263-.001c-2.241 0-3.157.268-3.532.586l-.043.039h7.15c-.334-.322-1.176-.603-3.312-.624z", fill: "currentColor" }))));
}

module.exports = SvgBus;
//# sourceMappingURL=Bus.js.map
